import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../openFlowRedux/tenant.actions';
import { MainSection } from '../style';
import BackGroundGenerator from '../../LandingPages/common/BackGroundGenerator';
import ForwardMessegeBox from '../../../../openbrix-design-system/ui/molecules/openflowHome/ForwardMessegeBox';

const Forwardmessege = (props) => {
  const dispatch = useDispatch();
  const [moveOutData, setMoveOutData] = useState(null);

  const reduxMoveOutData = useSelector((state) => state?.tenant?.moveOutData);
  const flowId = props?.route?.params?.id || (typeof window !== 'undefined' && window.location?.pathname?.split('/')?.pop());

  useEffect(() => {
    if (flowId) {
      fetchMoveOutData();
    }
  }, [flowId]);

  useEffect(() => {
    if (reduxMoveOutData) {
      setMoveOutData(reduxMoveOutData);
    }
  }, [reduxMoveOutData]);

  const fetchMoveOutData = () => {
    if (!flowId) return;
    dispatch(
      tenantActions.getMoveOutData(flowId, (data) => {
        setMoveOutData(data);
      })
    );
  };

  const handleSearchPostCode = (postCode, callback) => {
    dispatch(
      tenantActions.searchPostCode(postCode, (results) => {
        if (callback && typeof callback === 'function') {
          callback(results);
        }
      })
    );
  };

  const handleSaveForwardingAddress = (payload, callback) => {
    const targetFlowId = payload?.openflow_id || flowId;
    dispatch(
      tenantActions.updateForwardingAddress(targetFlowId, payload, (res) => {
        fetchMoveOutData();
        if (callback && typeof callback === 'function') {
          callback(res);
        }
      })
    );
  };

  const resolvedData = moveOutData?.data || moveOutData || reduxMoveOutData?.data || reduxMoveOutData;
  const forwardingAddresses = resolvedData?.open_flow_move_out_forwarding_addresses;
  let buttonTextVal = 0;
  if (Array.isArray(forwardingAddresses)) {
    const isCompleted = forwardingAddresses.some((address) => address?.tenant_confirm || address?.teanant_confirm);
    if (isCompleted) {
      buttonTextVal = 1;
    } else {
      buttonTextVal = forwardingAddresses.length > 0 ? 4 : 0;
    }
  } else {
    const finalAddress = resolvedData?.open_flow_move_out_forwarding_address || resolvedData?.forwarding_address;
    const isCompleted = finalAddress?.tenant_confirm || finalAddress?.teanant_confirm;
    buttonTextVal = finalAddress ? (isCompleted ? 1 : 4) : 0;
  }

  return (
    <BackGroundGenerator
      props={props}
      isTLYF
      isOpenflowContainer
      openFlowData={{
        title: 'Forwarding Address',
        desc: 'Please add your forwarding address and click confirm to send it to your agent.',
        buttonText: buttonTextVal,
        message: '',
        listIcon: 'location',
        iconColor: '#A070C4',
      }}
    >
      <MainSection>
        <ForwardMessegeBox
          data={moveOutData || reduxMoveOutData}
          onSearchPostCode={handleSearchPostCode}
          onSaveForwardingAddress={handleSaveForwardingAddress}
        />
      </MainSection>
    </BackGroundGenerator>
  );
};

const styles = StyleSheet.create({});
export default Forwardmessege;
